export default __webpack_public_path__ + "static/media/Scholar's Sandals of the Waning Moon.62e20a2e.jpg";